"use client";;
import CreatorLogo, { CreatorLogo_Skeleton } from '@/app/components/creators/CreatorLogo';
import useSocialUpdates from '@/app/hooks/useSocialUpdates';
import { ResponseError } from '@/lib/definitions';
import { cn } from '@/lib/utils';
import { mergeAttributes, NodeViewProps, NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import { CreatorLogo_server } from './CreatorLogo_server';

export const CreatorLogo_client = CreatorLogo_server.extend({
    renderHTML({ HTMLAttributes }) {
        return ['CreatorLogo', mergeAttributes(HTMLAttributes)];
    },
    addNodeView() {
        return ReactNodeViewRenderer(CreatorLogo_editor_component as any, { "contentDOMElementTag": "span" });
    },
})

function CreatorLogo_editor_component(props: NodeViewProps & { node: { attrs: { ytid: string, auto: boolean } } }) {
    const { ytid, auto } = props.node.attrs;
    let id = ytid || auto && new URL(window.location.href).searchParams.get("id");

    const { data: ytData, isLoading, error } = useSocialUpdates(id || "", true, auto);

    return <NodeViewWrapper data-drag-handle as={ "span" } className={ cn("inline-block", props.selected && "bg-nfPurple-500 rounded-xl") }>
        { (isLoading) && <CreatorLogo_Skeleton /> || <Content ytData={ ytData } /> }
    </NodeViewWrapper>
}

function Content({ ytData }: { ytData: ReturnType<typeof useSocialUpdates>["data"] }) {
    if (!ytData)
        return <CreatorLogo_Skeleton />
    if (ytData instanceof ResponseError)
        return <>יוצרי תוכן</>

    const { logo: image, id: ytid, name } = ytData;

    return <div className='flex items-center gap-2'>
        <CreatorLogo youtuber={ { ytid, name, image } } relativeToH={ false } />
        <span>{ name }</span>
    </div>

}